package hk.com.vr360_demo2.webapp.component.editor_rewrite.component

import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.img
import web.cssom.AlignItems
import web.cssom.Background
import web.cssom.Border
import web.cssom.BoxSizing
import web.cssom.Color
import web.cssom.Cursor
import web.cssom.Display
import web.cssom.FlexDirection
import web.cssom.JustifyContent
import web.cssom.LineStyle
import web.cssom.ObjectFit
import web.cssom.Overflow
import web.cssom.Position
import web.cssom.pct
import web.cssom.px
import kotlin.js.unsafeCast

external interface EditorInitialViewPanelProps : Props {
    var visible: Boolean
    var previewImage: String?
    var onConfirm: () -> Unit
}

private fun cornerStyle(position: String): dynamic {
    val style = js("({})")
    style.position = "absolute"
    style.width = "24px"
    style.height = "24px"
    style.pointerEvents = "none"
    when (position) {
        "top-left" -> {
            style.top = "-3px"
            style.left = "-3px"
            style.borderTop = "4px solid #f26522"
            style.borderLeft = "4px solid #f26522"
        }
        "top-right" -> {
            style.top = "-3px"
            style.right = "-3px"
            style.borderTop = "4px solid #f26522"
            style.borderRight = "4px solid #f26522"
        }
        "bottom-left" -> {
            style.bottom = "-3px"
            style.left = "-3px"
            style.borderBottom = "4px solid #f26522"
            style.borderLeft = "4px solid #f26522"
        }
        else -> {
            style.bottom = "-3px"
            style.right = "-3px"
            style.borderBottom = "4px solid #f26522"
            style.borderRight = "4px solid #f26522"
        }
    }
    return style
}

val EditorInitialViewPanel = FC<EditorInitialViewPanelProps> { props ->
    if (!props.visible) return@FC

    val imageSrc = if (!props.previewImage.isNullOrBlank()) {
        props.previewImage!!
    } else {
        "/assets/images/initial-view-placeholder.svg"
    }

    div {
        css {
            position = Position.absolute
            top = 0.px
            left = 0.px
            width = 100.pct
            height = 100.pct
            zIndex = 40.unsafeCast<web.cssom.ZIndex>()
            asDynamic().pointerEvents = "none"
        }

        div {
            css {
                position = Position.absolute
                right = 200.px
                top = 120.px
                width = 200.px
                border = Border(1.px, LineStyle.solid, Color("rgba(255, 255, 255, 0.15)"))
                asDynamic().borderRadius = "4px"
                asDynamic().padding = "16px 24px 24px"
                background = "rgba(0, 0, 0, 0.55)".unsafeCast<Background>()
                boxSizing = BoxSizing.borderBox
                asDynamic().pointerEvents = "auto"
            }
            div {
                css {
                    color = Color("#ffffff")
                    fontSize = 12.px
                    asDynamic().fontWeight = "700"
                    letterSpacing = 0.5.px
                    marginBottom = 8.px
                }
                +"初始視角"
            }
            div {
                css {
                    width = 100.pct
                    asDynamic().aspectRatio = "3 / 2"
                    border = Border(1.px, LineStyle.solid, Color("#ffffff"))
                    asDynamic().borderRadius = "2px"
                    overflow = Overflow.hidden
                    display = Display.flex
                    alignItems = AlignItems.center
                    justifyContent = JustifyContent.center
                    background = "rgba(0, 0, 0, 0.35)".unsafeCast<Background>()
                }
                img {
                    src = imageSrc
                    css {
                        width = 100.pct
                        height = 100.pct
                        objectFit = ObjectFit.cover
                        display = Display.block
                    }
                }
            }
        }

        div {
            css {
                position = Position.absolute
                top = 0.px
                left = 0.px
                width = 100.pct
                height = 100.pct
                display = Display.flex
                alignItems = AlignItems.center
                justifyContent = JustifyContent.center
            }
            div {
                css {
                    position = Position.relative
                    asDynamic().width = "min(450px, calc(100vw - 24px))"
                    asDynamic().height = "min(270px, calc((100vw - 24px) * 0.6))"
                    border = Border(2.px, LineStyle.dashed, Color("#ffffff"))
                    boxSizing = BoxSizing.borderBox
                }
                div { asDynamic().style = cornerStyle("top-left") }
                div { asDynamic().style = cornerStyle("top-right") }
                div { asDynamic().style = cornerStyle("bottom-left") }
                div { asDynamic().style = cornerStyle("bottom-right") }

                div {
                    css {
                        position = Position.absolute
                        left = 50.pct
                        bottom = 20.px
                        asDynamic().transform = "translate(-50%, -50%)"
                        asDynamic().pointerEvents = "auto"
                    }
                    button {
                        css {
                            border = 0.px
                            asDynamic().borderRadius = "8px"
                            asDynamic().padding = "6px 16px"
                            color = Color("#ffffff")
                            background = "#f26522".unsafeCast<Background>()
                            cursor = Cursor.pointer
                            hover {
                                background = "rgb(255, 131, 77)".unsafeCast<Background>()
                            }
                        }
                        onClick = { props.onConfirm() }
                        +"設置當前視角為初始視角"
                    }
                }
            }
        }
    }
}
